import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _merge from 'lodash/merge';

import Layout01 from './layout01';
import StationLegacy from './layout-station-legacy';
import Theme from './Theme';

import { useBrandingData } from './components/DataProviders';
import PoweredBy from './components/PoweredBy';
import { ReturnPolicyDialogProvider } from './components/ReturnPolicyDialog';


export const layouts = {
  layout01: Layout01,
  station_legacy: StationLegacy
};


const usePageStyles = makeStyles( theme => ({
  '@global': {
    'body': {
      ...theme.page,
      color: '#222222'
    },
    'a': {
      ..._merge( {}, theme.main, theme.link )
    }
  },
}), { name: 'PageStyles' });

const PageStyles = ({ children }) => {
  usePageStyles();
  return children; // Need a separate component b/c needs to be inside the `<Theme>` below
}


export default function Layout() {
  const branding = useBrandingData();
  let layoutKey = branding.layout_key;

  if( !layoutKey || layoutKey === 'layout00' ) {
    layoutKey = 'layout01';
  }

  let TheLayout = layouts[layoutKey];

  if( !TheLayout ) {
    // eslint-disable-next-line no-console
    console.warn(`Missing layout ${layoutKey}`);
    TheLayout = layouts.layout01;
  }

  return (
    <ReturnPolicyDialogProvider>
      <Theme config={branding} layout={TheLayout}>
        <PageStyles>
          <TheLayout />
          <PoweredBy />
        </PageStyles>
      </Theme>
    </ReturnPolicyDialogProvider>
  );
}
